const getDefaultDays = () => [0, 1, 2, 3, 4, 5, 6].map((day) => ({ id: day, enable: true }));

export default getDefaultDays;
